import Main from '../components/utils/Main';
import Details from '../components/nam/Details';
import Login from '../logIn/Login';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { AuthContext } from '../context/AuthContext';
import { useState } from 'react';
import Swagger from '../components/swagger/Swagger';
import Fallout from '../components/fallout/Fallout';
import UnofficialAddress from '../components/unofficialAddress/UnofficialAddress';



function App() {
  const [token, setToken] = useState(null);
  return (
    <BrowserRouter>
      <AuthenticatedTemplate>
        <AuthContext.Provider value={{ token, setToken }}>
          <Main>
            <Routes>
               <Route path="/unofficial-address" element={<UnofficialAddress />} />
              <Route path="/nam-swagger" element={<Swagger />} />
              <Route path="/fallout" element={<Fallout />} />
              <Route path="/nam" element={<Details />} />
              <Route path="/" element={<Navigate to="/nam" />} />
            </Routes>
          </Main>
        </AuthContext.Provider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </BrowserRouter>
  );
}

export default App;
